export const addPlaceholderImages = type => files => ({
    type,
    images: files
})

export const updatePlaceholder = type => placeholder => ({
    type,
    placeholder
})
